import React, { useState } from 'react';
import { Star, MessageSquare, Search, CheckCircle, Mail, FolderKanban } from 'lucide-react';
import { Button } from './ui/Button';
export const InfluencerHub = () => <section className="py-16 bg-white border-t border-gray-100" data-id="element-428">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-429">
      <div className="inline-flex items-center justify-center mb-6" data-id="element-430">
        <img src="https://cdn.magicpatterns.com/uploads/2roKm1Fk7NMWKUUjaFCrht/im_(2).png" alt="Top Influencer Marketplaces 2026 Badge" className="h-32 w-auto" data-id="element-431" />
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-432">
        Ranked #7 Best Influencer Marketing Marketplace
      </h2>
      <p className="text-gray-600 max-w-2xl mx-auto mb-4" data-id="element-433">
        Recognized by{' '}
        <a href="https://influencermarketinghub.com/influencer-marketplaces/" target="_blank" rel="noopener noreferrer" className="text-zano-pink hover:underline font-medium" data-id="element-434">
          Influencer Marketing Hub
        </a>{' '}
        for our unique approach to capture represented talent at scale —
        something no one else is doing.
      </p>
      <p className="text-sm text-gray-500 max-w-xl mx-auto" data-id="element-435">
        Zano was placed #7 because of our unique position in the market:
        providing direct access to the elite layer of talent representation and
        connecting brands with 400+ agencies managing 6,000+ creators.
      </p>
    </div>
  </section>;
export const CapterraReviews = () => <section className="py-16 bg-gray-50 border-t border-gray-100" data-id="element-436">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-437">
      <div className="flex justify-center mb-6" data-id="element-438">
        <a href="https://www.capterra.com/p/10027632/Zano/reviews/" target="_blank" rel="noopener noreferrer" data-id="element-439">
          <img src="https://brand-assets.capterra.com/badge/fa921502-adb9-4b73-b611-d6c5e380b1b0.svg" alt="Zano reviews on Capterra" className="h-20 w-auto" data-id="element-440" />
        </a>
      </div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-441">
        5-Star Rated on Capterra
      </h2>
      <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-442">
        Users love Zano for its ease of use and exceptional UX design.
        Navigating the platform and finding the right talent has never been
        simpler.
      </p>
    </div>
  </section>;
export const Newsletter = () => {
  const [submitted, setSubmitted] = useState(false);
  return <section className="py-20 bg-zano-charcoal text-white" data-id="element-443">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-444">
        <Mail className="mx-auto text-zano-pink mb-6" size={32} data-id="element-445" />
        <h2 className="text-3xl font-bold mb-4" data-id="element-446">Subscribe to our Newsletter</h2>
        <p className="text-gray-300 mb-8" data-id="element-447">
          Get industry insights from the agency perspective, discover top
          agencies and represented influencers on Zano, and stay updated on
          platform features and casting calls.
        </p>
        {submitted ? <div className="flex items-center justify-center gap-2 text-white font-medium" data-id="element-448">
            <CheckCircle className="text-green-400" size={20} data-id="element-449" /> Thanks — you're
            subscribed.
          </div> : <form onSubmit={e => {
        e.preventDefault();
        setSubmitted(true);
      }} className="flex flex-col sm:flex-row gap-3 justify-center max-w-md mx-auto" data-id="element-450">
            <input type="email" placeholder="Enter your email" className="px-4 py-3 rounded-lg text-gray-900 w-full outline-none focus:ring-2 focus:ring-zano-pink" required data-id="element-451" />
            <Button variant="primary" className="whitespace-nowrap" type="submit" data-id="element-452">
              Subscribe
            </Button>
          </form>}
      </div>
    </section>;
};
import { Reveal } from './ui/Reveal';
import { FileImage, BarChart3, Sparkles, Send, CheckCircle2, ShieldCheck, Download, TrendingUp } from 'lucide-react';
export const CreatorAssetOS = () => <section className="py-24 bg-gray-50 border-t border-gray-100 overflow-hidden" data-id="element-453">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-454">
      <Reveal data-id="element-455">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-456">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-zano-blush text-zano-pink text-xs font-semibold border border-zano-pink/20 mb-5" data-id="element-457">
            <Sparkles size={13} data-id="element-458" /> Coming Soon
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-459">
            The Creator Asset OS for the elite market
          </h2>
          <p className="text-lg text-gray-600" data-id="element-460">
            We're building the operating system for agency-to-agency and
            agency-to-brand collaborations. A complete suite to discover,
            manage, and analyze your creator partnerships.
          </p>
        </div>
      </Reveal>

      <div className="space-y-8" data-id="element-461">
        {/* Discovery Layer */}
        <Reveal delay={0.1} data-id="element-462">
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-463">
            <div className="p-8 border-b border-gray-100 bg-gradient-to-r from-blue-50/50 to-transparent" data-id="element-464">
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-465">
                1. Enhancing our Discovery Layer
              </h3>
              <p className="text-gray-600 max-w-2xl" data-id="element-466">
                Finding the right talent and verifying representation is about
                to get even easier.
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-100" data-id="element-467">
              {/* Live Chat */}
              <div className="p-6 flex flex-col" data-id="element-468">
                <div className="flex-1" data-id="element-469">
                  <div className="w-10 h-10 bg-blue-50 text-blue-600 rounded-lg flex items-center justify-center mb-4" data-id="element-470">
                    <MessageSquare size={20} data-id="element-471" />
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-472">Live Chat</h4>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6" data-id="element-473">
                    Brands, marketing agencies, and talent agencies can speak
                    directly to each other on Zano, keeping communication
                    centralized.
                  </p>
                </div>
                {/* Mockup */}
                <div className="bg-gray-50 rounded-xl border border-gray-200 p-3 h-40 flex flex-col justify-end relative overflow-hidden" data-id="element-474">
                  <div className="space-y-3 w-full" data-id="element-475">
                    <div className="flex gap-2 items-end" data-id="element-476">
                      <div className="w-6 h-6 rounded-full bg-gray-300 shrink-0" data-id="element-477"></div>
                      <div className="bg-white border border-gray-200 rounded-2xl rounded-bl-sm px-3 py-2 text-[10px] text-gray-600 shadow-sm" data-id="element-478">
                        Are they available for a Q3 campaign?
                      </div>
                    </div>
                    <div className="flex gap-2 items-end justify-end" data-id="element-479">
                      <div className="bg-zano-pink text-white rounded-2xl rounded-br-sm px-3 py-2 text-[10px] shadow-sm" data-id="element-480">
                        Yes, let's discuss rates!
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 bg-white border border-gray-200 rounded-full flex items-center px-3 py-1.5 shadow-sm" data-id="element-481">
                    <span className="text-[10px] text-gray-400 flex-1" data-id="element-482">
                      Type a message...
                    </span>
                    <Send size={12} className="text-zano-pink" data-id="element-483" />
                  </div>
                </div>
              </div>

              {/* Influencer Verification */}
              <div className="p-6 flex flex-col" data-id="element-484">
                <div className="flex-1" data-id="element-485">
                  <div className="w-10 h-10 bg-emerald-50 text-emerald-600 rounded-lg flex items-center justify-center mb-4" data-id="element-486">
                    <CheckCircle size={20} data-id="element-487" />
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-488">
                    Influencer Verification
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6" data-id="element-489">
                    Talent agencies can ask influencers to opt in, displaying a
                    checkmark that confirms their talent manager as their
                    agent—making Zano the source of truth.
                  </p>
                </div>
                {/* Mockup */}
                <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 h-40 flex items-center justify-center relative overflow-hidden" data-id="element-490">
                  <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm w-full max-w-[200px] text-center relative" data-id="element-491">
                    <div className="absolute -top-3 -right-3 bg-emerald-100 text-emerald-600 rounded-full p-1.5 shadow-sm border border-emerald-200" data-id="element-492">
                      <ShieldCheck size={16} data-id="element-493" />
                    </div>
                    <div className="w-12 h-12 bg-gray-200 rounded-full mx-auto mb-2 relative" data-id="element-494">
                      <div className="absolute bottom-0 right-0 bg-blue-500 text-white rounded-full p-0.5 border-2 border-white" data-id="element-495">
                        <CheckCircle2 size={10} data-id="element-496" />
                      </div>
                    </div>
                    <div className="font-bold text-gray-900 text-xs" data-id="element-497">
                      Elena Rodriguez
                    </div>
                    <div className="text-[10px] text-gray-500 mt-1" data-id="element-498">
                      Represented by UTA
                    </div>
                    <div className="mt-2 inline-flex items-center gap-1 bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded-full text-[9px] font-medium border border-emerald-200" data-id="element-499">
                      <CheckCircle2 size={10} data-id="element-500" /> Verified Representation
                    </div>
                  </div>
                </div>
              </div>

              {/* AI Search & Discovery */}
              <div className="p-6 flex flex-col" data-id="element-501">
                <div className="flex-1" data-id="element-502">
                  <div className="w-10 h-10 bg-purple-50 text-purple-600 rounded-lg flex items-center justify-center mb-4" data-id="element-503">
                    <Search size={20} data-id="element-504" />
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2" data-id="element-505">
                    AI Search & Discovery
                  </h4>
                  <p className="text-sm text-gray-600 leading-relaxed mb-6" data-id="element-506">
                    Automatically tagging content and helping you find those
                    highly specific, niche creators that brands need for
                    targeted campaigns.
                  </p>
                </div>
                {/* Mockup */}
                <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 h-40 flex flex-col justify-center relative overflow-hidden" data-id="element-507">
                  <div className="bg-white border-2 border-purple-200 rounded-lg p-2 flex items-center gap-2 shadow-sm mb-3" data-id="element-508">
                    <Sparkles size={14} className="text-purple-500 shrink-0" data-id="element-509" />
                    <span className="text-[10px] text-gray-800 font-medium" data-id="element-510">
                      "NYC foodies with high engagement"
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-1.5" data-id="element-511">
                    <span className="bg-purple-50 text-purple-700 border border-purple-100 px-2 py-1 rounded text-[9px] font-medium" data-id="element-512">
                      #nyceats
                    </span>
                    <span className="bg-purple-50 text-purple-700 border border-purple-100 px-2 py-1 rounded text-[9px] font-medium" data-id="element-513">
                      Engagement &gt; 5%
                    </span>
                    <span className="bg-purple-50 text-purple-700 border border-purple-100 px-2 py-1 rounded text-[9px] font-medium" data-id="element-514">
                      Location: NYC
                    </span>
                  </div>
                  <div className="mt-3 flex items-center gap-2" data-id="element-515">
                    <div className="flex -space-x-2" data-id="element-516">
                      <div className="w-6 h-6 rounded-full bg-gray-300 border-2 border-white" data-id="element-517"></div>
                      <div className="w-6 h-6 rounded-full bg-gray-400 border-2 border-white" data-id="element-518"></div>
                      <div className="w-6 h-6 rounded-full bg-gray-500 border-2 border-white" data-id="element-519"></div>
                    </div>
                    <span className="text-[10px] text-gray-500 font-medium" data-id="element-520">
                      +24 matches found
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-521">
          {/* Campaign Management */}
          <Reveal delay={0.2} className="h-full" data-id="element-522">
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 h-full flex flex-col hover:border-zano-pink/30 hover:shadow-float transition-all duration-300" data-id="element-523">
              <div className="flex-1" data-id="element-524">
                <div className="w-12 h-12 bg-orange-50 text-orange-600 rounded-xl flex items-center justify-center mb-6" data-id="element-525">
                  <FolderKanban size={24} data-id="element-526" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-527">
                  2. Campaign Management
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-528">
                  Handle the entire lifecycle of a deal in one place. Manage
                  briefs, set up negotiations, review drafts, handle approvals,
                  and track final deliverables without leaving the platform.
                </p>
              </div>
              {/* Mockup */}
              <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 relative overflow-hidden" data-id="element-529">
                <div className="flex justify-between items-center mb-3" data-id="element-530">
                  <span className="text-[10px] font-bold text-gray-700 uppercase" data-id="element-531">
                    Summer Launch
                  </span>
                  <span className="text-[9px] bg-orange-100 text-orange-700 px-2 py-0.5 rounded-full font-medium" data-id="element-532">
                    In Progress
                  </span>
                </div>
                <div className="space-y-2" data-id="element-533">
                  <div className="flex items-center gap-2" data-id="element-534">
                    <CheckCircle2 size={14} className="text-emerald-500" data-id="element-535" />
                    <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-536">
                      <div className="w-full h-full bg-emerald-500" data-id="element-537"></div>
                    </div>
                    <span className="text-[9px] text-gray-500 w-12" data-id="element-538">Brief</span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-539">
                    <CheckCircle2 size={14} className="text-emerald-500" data-id="element-540" />
                    <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-541">
                      <div className="w-full h-full bg-emerald-500" data-id="element-542"></div>
                    </div>
                    <span className="text-[9px] text-gray-500 w-12" data-id="element-543">
                      Negotiate
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-544">
                    <div className="w-3.5 h-3.5 rounded-full border-2 border-orange-400" data-id="element-545"></div>
                    <div className="flex-1 h-1.5 bg-gray-200 rounded-full overflow-hidden" data-id="element-546">
                      <div className="w-1/2 h-full bg-orange-400" data-id="element-547"></div>
                    </div>
                    <span className="text-[9px] text-gray-900 font-medium w-12" data-id="element-548">
                      Drafts
                    </span>
                  </div>
                  <div className="flex items-center gap-2 opacity-50" data-id="element-549">
                    <div className="w-3.5 h-3.5 rounded-full border-2 border-gray-300" data-id="element-550"></div>
                    <div className="flex-1 h-1.5 bg-gray-200 rounded-full" data-id="element-551"></div>
                    <span className="text-[9px] text-gray-500 w-12" data-id="element-552">
                      Approval
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Asset Management */}
          <Reveal delay={0.3} className="h-full" data-id="element-553">
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 h-full flex flex-col hover:border-zano-pink/30 hover:shadow-float transition-all duration-300" data-id="element-554">
              <div className="flex-1" data-id="element-555">
                <div className="w-12 h-12 bg-pink-50 text-pink-600 rounded-xl flex items-center justify-center mb-6" data-id="element-556">
                  <FileImage size={24} data-id="element-557" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-558">
                  3. Asset & Licensing
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-559">
                  A dedicated layer for asset management and licensing rights.
                  Securely store final content, track usage rights, and manage
                  licensing agreements seamlessly.
                </p>
              </div>
              {/* Mockup */}
              <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 relative overflow-hidden" data-id="element-560">
                <div className="grid grid-cols-2 gap-2 mb-2" data-id="element-561">
                  <div className="bg-gray-200 rounded-lg h-16 relative group overflow-hidden" data-id="element-562">
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-563">
                      <Download size={14} className="text-white" data-id="element-564" />
                    </div>
                    <div className="absolute bottom-1 left-1 bg-black/60 text-white text-[8px] px-1.5 rounded" data-id="element-565">
                      MP4
                    </div>
                  </div>
                  <div className="bg-gray-200 rounded-lg h-16 relative group overflow-hidden" data-id="element-566">
                    <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-567">
                      <Download size={14} className="text-white" data-id="element-568" />
                    </div>
                    <div className="absolute bottom-1 left-1 bg-black/60 text-white text-[8px] px-1.5 rounded" data-id="element-569">
                      JPG
                    </div>
                  </div>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg p-2 flex items-center justify-between shadow-sm" data-id="element-570">
                  <div className="flex items-center gap-1.5" data-id="element-571">
                    <ShieldCheck size={14} className="text-emerald-500" data-id="element-572" />
                    <span className="text-[10px] font-medium text-gray-800" data-id="element-573">
                      Usage Rights
                    </span>
                  </div>
                  <span className="text-[9px] text-gray-500" data-id="element-574">
                    Expires in 6 mo
                  </span>
                </div>
              </div>
            </div>
          </Reveal>

          {/* Reporting */}
          <Reveal delay={0.4} className="h-full" data-id="element-575">
            <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 h-full flex flex-col hover:border-zano-pink/30 hover:shadow-float transition-all duration-300" data-id="element-576">
              <div className="flex-1" data-id="element-577">
                <div className="w-12 h-12 bg-indigo-50 text-indigo-600 rounded-xl flex items-center justify-center mb-6" data-id="element-578">
                  <BarChart3 size={24} data-id="element-579" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-580">
                  4. Reporting & Analytics
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-6" data-id="element-581">
                  Analyze campaign performance with comprehensive reporting
                  tools. Measure ROI, track engagement metrics, and generate
                  beautiful reports for your clients.
                </p>
              </div>
              {/* Mockup */}
              <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 relative overflow-hidden" data-id="element-582">
                <div className="flex justify-between items-end mb-4" data-id="element-583">
                  <div data-id="element-584">
                    <span className="text-[10px] text-gray-500 block mb-0.5" data-id="element-585">
                      Total Reach
                    </span>
                    <span className="text-lg font-bold text-gray-900" data-id="element-586">
                      4.2M
                    </span>
                  </div>
                  <div className="flex items-center gap-1 text-emerald-500 bg-emerald-50 px-1.5 py-0.5 rounded text-[10px] font-medium" data-id="element-587">
                    <TrendingUp size={10} data-id="element-588" /> +12%
                  </div>
                </div>
                <div className="flex items-end gap-1.5 h-12 border-b border-gray-200 pb-1" data-id="element-589">
                  <div className="w-full bg-indigo-200 rounded-t-sm h-[40%]" data-id="element-590"></div>
                  <div className="w-full bg-indigo-300 rounded-t-sm h-[60%]" data-id="element-591"></div>
                  <div className="w-full bg-indigo-400 rounded-t-sm h-[45%]" data-id="element-592"></div>
                  <div className="w-full bg-indigo-500 rounded-t-sm h-[80%]" data-id="element-593"></div>
                  <div className="w-full bg-indigo-600 rounded-t-sm h-[100%] relative" data-id="element-594">
                    <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-[8px] px-1.5 py-0.5 rounded shadow-sm whitespace-nowrap" data-id="element-595">
                      Peak
                    </div>
                  </div>
                </div>
                <div className="flex justify-between mt-1" data-id="element-596">
                  <span className="text-[8px] text-gray-400" data-id="element-597">Mon</span>
                  <span className="text-[8px] text-gray-400" data-id="element-598">Fri</span>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>;